import React, { useEffect, useState, useRef } from 'react';
import { get, post, put, destroy, getReport } from '../services/apiController';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { DeleteIcon, DownloadIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../src/img.svg';
import { GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../components/Breadcrumb';
import { banks } from '../util/helper';

export default function AddEntry() {
  const formFields = { date: '', time: '', userName: '', image: '', bankName: '', collections: [], isHoliday: false };
  const [totalRecords, setTotalRecords] = useState(0);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [idToDeleted, setIdToDeleted] = useState('');
  const [deleteModel, setDeleteModel] = useState(false);
  const [collectionForm, setCollectionForm] = useState(formFields);
  const [collection, setCollection] = useState([]);
  const [userList, setUserList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [collectionDate, setCollectionDate] = useState(new Date().toJSON().slice(0, 10));
  const clickToDownload = useRef(null);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onChangeFile = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    convertToBase64(file)
      .then((base64Image) => {
        setCollectionForm({ ...collectionForm, image: base64Image.split('base64,')[1] });
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const handleShow = () => {
    setShowConfirmModel(true);
    setCollectionForm(formFields);
  };

  const handleCloseModal = () => {
    setShowConfirmModel(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await post(collectionForm, '/collections/');
      toast.success('Collection added successfully');
      setShowConfirmModel(false);
      getCollection();
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
    }
  };

  const collectAmount = (e, branchId) => {
    const _collections = [...collectionForm.collections];
    const index = _collections.findIndex((coll) => coll.branch_id === branchId);
    if (index === -1) {
      _collections.push({ branch_id: branchId, amount: e.target.value });
    } else {
      _collections[index] = { branch_id: branchId, amount: e.target.value };
    }
    setCollectionForm({ ...collectionForm, collections: _collections });
  };

  const handleUserSelect = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    setSelectedValue(e.target.value);
    if (e.target.value !== '') {
      getBranchDropdown(e.target.value);
    }
    setCollectionForm({ ...collectionForm, [name]: value });
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _form = { ...collectionForm, [name]: value };
    if (name === 'isHoliday') {
      _form = { ..._form, bankName: '' };
    }
    setCollectionForm(_form);
  };

  const handleConfirmDeleteModal = (e, id) => {
    e.preventDefault();
    setDeleteModel(true);
    setIdToDeleted(id);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    try {
      destroy('/collections/' + id).then((response) => {
        toast.success('Collection deleted successfully');
        setDeleteModel(false);
        getCollection();
      });
    } catch (err) {
      toast.error(err.message, { autoClose: 3000 });
    }
  };

  const getCollection = () => {
    getReport(`/collections/report/?dateFrom=${collectionDate}&dateTo=${collectionDate}`).then((response) => {
      setCollection(response.data);
      setTotalRecords(response.data.length);
    });
  };

  const filterSubmit = () => {
    getCollection();
  };

  const filterDownload = async () => {
    const data = await getReport(`/collections/report/?dateFrom=${collectionDate}&dateTo=${collectionDate}&conditionType=download`);
    clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data.data.filePath}`;
    setTimeout(() => {
      clickToDownload.current.click();
    }, 500);
  };

  const statusChange = (event, collectionId) => {
    event.preventDefault();
    try {
      put({ status: event.target.value }, '/collections/' + collectionId).then((response) => {
        toast.success('Status Updated');
        getCollection();
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  const getUser = () => {
    get('/users').then((response) => {
      setUserList(response?.data?.data);
    });
  };

  const getBranchDropdown = (userId) => {
    get(`/users/${userId}/branches`).then((response) => {
      setBranchList(response.data);
    });
  };

  useEffect(() => {
    getCollection();
    getUser();
  }, []);

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Store Operations' },
          { link: '#', title: 'Cash Collection' },
          { link: '#', title: 'Entries' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Collections | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={collectionDate}
              onChange={(e) => setCollectionDate(e.target.value)}
              type="date"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" style={{ marginRight: '20px' }} onClick={filterSubmit} className="btn app-btn-default dark-color">
              Apply
            </button>
            <GrDocumentExcel title="Download Collections Report" className="react-icons green" onClick={filterDownload} />
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
              Add New
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr className="text-center">
                    <th>#</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Amount To Bank</th>
                    <th>Amount To Office</th>
                    <th>Bank Name</th>
                    <th>Created By</th>
                    <th>Collection Center</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {collection.map((item, index) => {
                    return (
                      <tr className="text-center" key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.date ? new Date(item?.date).toLocaleDateString('en-GB') : '-'}</td>
                        <td>{item?.time || '-'}</td>
                        <td>{item?.amount || '-'}</td>
                        <td>{item?.amountToOffice || '-'}</td>
                        <td>{item?.bankName ? banks[item.bankName] : '-'}</td>
                        <td>{item?.user_name || '-'}</td>
                        <td>{item?.name}</td>
                        <td>
                          {item?.status !== null ? (
                            <select
                              size="sm"
                              disabled={item.status === 'credited'}
                              value={item?.status}
                              onChange={(e) => statusChange(e, item.collection_id)}
                              aria-label="Status"
                            >
                              {item.status === 'collected' ? <option value="collected">Collected</option> : ''}
                              <option value="credited">Credited</option>
                              <option value="not-credited">Not Credited</option>
                            </select>
                          ) : (
                            '-'
                          )}
                        </td>
                        <td className="actions">
                          {item?.image !== null ? (
                            <a
                              href={
                                item?.syncedOnBucket
                                  ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.image}`
                                  : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item?.image}`
                              }
                            >
                              <DownloadIcon style={{ color: 'purple' }} />
                            </a>
                          ) : (
                            ''
                          )}
                          {item.status === 'collected' ? (
                            <Link onClick={(e) => handleConfirmDeleteModal(e, item?.collection_id)} className="delete" to="/">
                              <DeleteIcon />
                            </Link>
                          ) : (
                            ''
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="text-center" style={{ backgroundColor: '#f3f6f9', fontWeight: '400' }}>
                    <td colSpan="3">Total:</td>
                    <td>₹ {collection.reduce((total, item) => total + (item.amount || 0), 0)}</td>
                    <td>₹ {collection.reduce((total, item) => total + (item.amountToOffice || 0), 0)}</td>
                    <td colSpan="4">
                      Grand Total: ₹ {collection.reduce((total, item) => total + (item.amount || 0) + (item.amountToOffice || 0), 0)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <Modal size="sm" show={deleteModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Collection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="alert icon" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={() => setDeleteModel(false)} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title> Add Collection Detail</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="bottom-content">
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Date" className="mb-3">
                  <Form.Control
                    className="input"
                    value={collectionForm.date}
                    name="date"
                    onChange={handleChange}
                    type="date"
                    placeholder="Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Time" className="mb-3">
                  <Form.Control
                    className="input"
                    value={collectionForm.time}
                    name="time"
                    onChange={handleChange}
                    type="time"
                    placeholder="Time"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>

            <Row className="bottom-content">
              <Col xs={4}>
                <FloatingLabel label="User" className="mb-3">
                  <select
                    value={collectionForm.userName}
                    name="userName"
                    onChange={handleUserSelect}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option value="">Select User</option>
                    {userList
                      .filter((item) => Object.keys(item?.role).includes('store-manager'))
                      .map((item) => {
                        return (
                          <option key={item?.id} value={item.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel label="Is Bank Off Today" className="mb-3">
                  <select
                    name="isHoliday"
                    value={collectionForm.isHoliday}
                    onChange={handleChange}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                {(collectionForm.isHoliday === false || collectionForm.isHoliday === 'false') && (
                  <FloatingLabel label="Bank Name" className="mb-3">
                    <select
                      name="bankName"
                      value={collectionForm.bankName}
                      onChange={handleChange}
                      aria-label="Floating label select example"
                      className="form-select"
                    >
                      <option value="">Select Bank</option>
                      <option value="hdfc-bank">HDFC Bank</option>
                      <option value="icici-bank">ICICI Bank</option>
                      <option value="axis-bank">Axis Bank</option>
                    </select>
                  </FloatingLabel>
                )}
              </Col>
            </Row>
            {selectedValue !== '' ? (
              <Row>
                {branchList.map((branch) => {
                  return (
                    <Col key={branch?.id} xs={4}>
                      <FloatingLabel name="collections" label={`Amount from ${branch.name}`} className="mb-3">
                        <Form.Control
                          placeholder="Amount"
                          onChange={(e) => collectAmount(e, branch.id)}
                          type="number"
                          name={`amount[${branch.id}]`}
                          aria-required="false"
                        />
                      </FloatingLabel>
                    </Col>
                  );
                })}
              </Row>
            ) : null}
            <Row>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-4 images-box">
                  <Form.Label>Upload image</Form.Label>
                  <Form.Control onChange={(e) => onChangeFile(e)} required type="file" name="image" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
